import React, { useState, useEffect } from "react"
import Button from "../../../../components/Button/Button"
import { useDispatch } from "react-redux"
import { showSnackBar } from "../../../../components/Snackbar/Snackbar"
import { useMyContextLoading } from "../../../../components/LoadingContextProvider/LoadingContextProvider"
import { StorageGetItem, USER } from "../../../../lib/storage"
import { sendProposalEmail } from "../../../../features/contacts/contacts"
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

export const ProposalButton = ({
  userId,
  programPlan,
  paymentSchedule,
  userInfo,
  selectedCreditLines
}) => {
  const dispatch = useDispatch()
  const { triggerLoading } = useMyContextLoading()
  const [currentUser, setCurrentUser] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)

  useEffect(() => {
    StorageGetItem(USER).then(result => {
      setCurrentUser(result)
    })
  }, [])

  // The proposal goes to the rep, and the server reads only the client's name, so a client with no email
  // (PACK, WS #2219705) does not block it.
  const validateLeadData = () => {
    if (!programPlan?.plan || !programPlan?.programFee) {
      showSnackBar("error", "Program plan details are incomplete")
      return false
    }
    if (!paymentSchedule?.frequency || !paymentSchedule?.cycleStartDate) {
      showSnackBar("error", "Payment schedule details are incomplete")
      return false
    }
    return true
  }

  const handleSendProposal = async () => {
    if (!validateLeadData()) {
      return
    }

    triggerLoading(true)
    try {
      const leadData = {
        customerInfo: {
          name: `${userInfo.firstName} ${userInfo.lastName}`,
          email: userInfo.email,
          phone: userInfo.primaryPhone
        },
        programDetails: {
          plan: programPlan.plan,
          programFee: programPlan.programFee,
          custodialFee: programPlan.custodialFee,
          initialFee: programPlan.initialFee,
          totalAmount: programPlan.amount
        },
        paymentDetails: {
          frequency: paymentSchedule.frequency,
          startDate: paymentSchedule.cycleStartDate,
          secondDate: paymentSchedule.secondDate,
          estimatedPayments: paymentSchedule.tableData
        },
        creditLines: selectedCreditLines,
        affiliateInfo: {
          name: currentUser?.name,
          email: currentUser?.email,
          company: currentUser?.company || "FDR"
        }
      }

      const response = await dispatch(sendProposalEmail({ leadData, userId }))

      if (response.error) {
        showSnackBar("error", response.payload || "Failed to send proposal")
      } else {
        showSnackBar("success", `Proposal email sent successfully to ${currentUser?.email}`)
      }
    } catch (error) {
      showSnackBar("error", "Something went wrong while sending the proposal")
    } finally {
      triggerLoading(false)
      setOpenConfirmDialog(false)
    }
  }

  const handleOpenConfirmDialog = () => {
    if (validateLeadData()) {
      setOpenConfirmDialog(true)
    }
  }

  return (
    <>
      <Button
        type="outlined"
        onClick={handleOpenConfirmDialog}
      >
        Send Proposal
      </Button>

      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            padding: '16px',
            borderRadius: '24px'
          }
        }}
      >
        <DialogTitle id="confirm-dialog-title">
          Confirm Send Proposal
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            Are you sure you want to send the proposal email to {currentUser?.email}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            type='outlined'
            onClick={() => setOpenConfirmDialog(false)}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSendProposal}
            autoFocus
          >
            Send Proposal
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}